import * as React from "react";
import { Progress } from "antd";
import { useNavigate } from "react-router-dom";
import { usePointCard } from "@njoy/controller";
import Badge from "../../assets/svg/badgeicon.svg";
import PurpleNjoy from "../../assets/profile/purpleNjoy.svg";
import Explorer from "../../assets/profile/explorer.svg";
import Insider from "../../assets/profile/insider.svg";
import Gold from "../../assets/profile/gold.svg";
import Black from "../../assets/profile/black.svg";
import * as ROUTES from "../../constants/routes";

/** The member's points, tier and progress to the next tier. `children` sit under the card. */
export const PointsBalanceCard: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  const navigate = useNavigate();
  const {
    customerTier,
    pointBalance,
    tiers,
    pointsForNextTier,
    loading: pointsCardLoading,
  } = usePointCard();

  const progressPercent = Math.min(
    (pointBalance / (pointBalance + pointsForNextTier)) * 100,
    100,
  );

  return (
    <div className="w-full rounded-[10px] p-5 bg-[linear-gradient(180deg,_#FFFFFF_0%,_#C7D0FF_100%)]">
      <div className="flex items-center justify-between">
        <div className="flex gap-1 items-center mb-3">
          <img src={Badge} alt="" width={17} height={18} />
          <p className="text-[#353535] font-extrabold text-base">
            Points Balance
          </p>
        </div>
        <div
          className="flex items-center gap-1 justify-end text-[#353535]  text-xs mb-3 cursor-pointer"
          onClick={() => navigate(ROUTES.POINTS_OVERVIEW)}
        >
          Check Activity <span aria-hidden="true">›</span>
        </div>
      </div>

      <div
        className="bg-[#353535] rounded-[8px] cursor-pointer"
        onClick={() => navigate(ROUTES.POINTS_OVERVIEW)}
      >
        <div className=" p-4 flex flex-col gap-2 ">
          <div className="flex justify-end items-center  gap-1">
            <img
              src={
                customerTier === "Explorer"
                  ? Explorer
                  : customerTier === "Insider"
                    ? Insider
                    : customerTier === "Gold"
                      ? Gold
                      : Black
              }
              alt=""
              width={18}
              height={18}
            />
            <p className="text-base text-white font-extrabold">
              {pointsCardLoading ? "..." : customerTier}
            </p>
          </div>
          <div className="flex justify-between items-end mt-2">
            <div className="flex flex-col gap-1">
              <p className="text-xs text-white">Your Current Points</p>

              <div className="flex items-center gap-1">
                <img src={PurpleNjoy} alt="debit" width={13} height={11} />
                <h2 className="text-2xl text-white font-extrabold">
                  {pointsCardLoading ? "..." : pointBalance}
                </h2>
              </div>
            </div>
            <div className="mb-[6px] text-xs bg-[linear-gradient(180deg,_#FFFFFF_0%,_#C7D0FF_100%)] text-[#353535] px-2 py-[2px] rounded-md inline-block ">
              {pointsCardLoading ? "..." : pointsForNextTier} points to{" "}
              <span className="bg-[linear-gradient(270deg,_#FF8800_0%,_#FF165C_100%)] bg-clip-text text-transparent font-bold">
                {pointsCardLoading
                  ? "..."
                  : tiers.find(
                      (cur) =>
                        cur.threshold === pointBalance + pointsForNextTier,
                    )?.name}{" "}
                Tier
              </span>
            </div>
          </div>

          <Progress
            percent={progressPercent}
            showInfo={false}
            strokeColor={{
              "0%": "#3B82F6",
              "100%": "#A855F7",
            }}
            trailColor="#4B5563"
            strokeWidth={8}
            className="mb-2"
            style={{ transition: "all 0.3s ease" }}
          />
        </div>
      </div>
      {children}
    </div>
  );
};
